import { useEffect, useState } from 'react';
import { ReactComponent as GreenTick} from "../../../../assets/icons/green-tick.svg";
import { ReactComponent as RedCross} from "../../../../assets/icons/red-cross.svg";
import Styles from './index.module.scss';

const Policy = ({ password, policyName, policyRegex }) => {
    const [ checkPassed, setPasswordCheck ] = useState(false);
    
    useEffect(()=>{
        setPasswordCheck(password ? policyRegex.test(password) : false);
    },[ password ])

    const renderTick = () => {
        if(password){
            return (checkPassed ? <GreenTick/> : <RedCross/>)
        } else {
            return <span className={Styles.bullet}></span>
        }
    }

    return (
        <div className={Styles.list}>
            { renderTick() }
            <span>{policyName}</span>
        </div>
    );
};

export default Policy;